module.exports = __webpack_public_path__ + "img/ESG_aloldalhoz_grafikak_04_mobil.5fd6ecb0.jpg";